import Config from '@/config'
import { Button, ButtonText } from '@/ui/core/button'
import { Header } from '@/ui/core/header'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { Linking } from 'react-native'

/** The sign-up site, in the browser rather than inside the app, on every platform. */
export const joinWally = () => {
	Linking.openURL(`${Config.JOIN_URL}?utm_source=patient_app`)
}

/** "New to Wally? Join", as one line of text with the link set in it. */
export const JoinLine = ({ tone = 'white' }: { tone?: 'white' | 'soft' }) => (
	<Text
		size="body1"
		tone={tone}
		className={tone === 'white' ? 'opacity-85 text-center' : 'text-center'}
	>
		New to Wally?{' '}
		<Text
			size="body1"
			weight="bold"
			tone={tone === 'white' ? 'white' : 'ink'}
			underlined
			onPress={joinWally}
			accessibilityRole="link"
			accessibilityLabel="Join Wally at carebywally.com"
		>
			Join
		</Text>
	</Text>
)

/**
 * The first thing a signed-out launch shows: the photograph, the brand's words, and one button.
 * Members tap Log In; everyone else finds the way to join. The form waits behind the button so
 * the door stays clean.
 */
export const LoginWelcome = ({ onLogIn }: { onLogIn: () => void }) => (
	<VStack className="w-full" gap={24}>
		<VStack gap={10}>
			<VStack gap={6}>
				<Header variant="h7" tone="white">
					Members only
				</Header>
				<Header variant="h2" tone="white" className="text-[40px] leading-[40px]">
					{"Wally's new\nrules of dental"}
				</Header>
			</VStack>
			<Text size="body0" tone="white" className="opacity-85">
				Painless cleanings, Swiss tech, and a care team that texts back.
			</Text>
		</VStack>
		<VStack gap={14}>
			<Button
				variant="ground"
				size="lg"
				fullWidth
				className="bg-white border-white"
				onPress={onLogIn}
			>
				<ButtonText>Log In</ButtonText>
			</Button>
			<JoinLine />
		</VStack>
	</VStack>
)
